import { exploded } from "utils/time";

export const navigation = exploded()
  ? [
      {
        id: "1DES5",
        title: "History",
        url: "/history",
        subMenus: [],
      },
    ]
  : [
      {
        id: "1DES5",
        title: "History",
        url: "/history",
        subMenus: [],
      },
      {
        id: "1EDR5",
        title: "Airdrop",
        url: "/airdrop",
        subMenus: [],
      },
    ];
